import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';
import ResumeDetailPage from './pages/ResumeDetailPage';
import ResumeFormPage from './pages/ResumeFormPage';
import UsersPage from './pages/UsersPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import UnsubscribePage from './pages/UnsubscribePage';
import './styles/global.css';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} />;
  if (adminOnly && !user.is_admin) return <Navigate to="/search" />;
  return children;
}
function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/search" /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/search" />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="resumes/:recno" element={<ResumeDetailPage />} />
        <Route path="resumes/:recno/edit" element={<ProtectedRoute adminOnly><ResumeFormPage /></ProtectedRoute>} />
        <Route path="resumes/new" element={<ProtectedRoute adminOnly><ResumeFormPage /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      <Route path="*" element={<Navigate to="/search" />} />
      <Route path="*" element={<Navigate to="/search" />} />
    </Routes>
  );
}
export default function App() {
  // Apply saved theme on mount
  React.useEffect(() => {
    const saved = localStorage.getItem('theme') || 'dark';
    document.documentElement.setAttribute('data-theme', saved);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ style: { background: 'var(--bg-elevated)', color: 'var(--text-primary)', border: '1px solid var(--border-light)', borderRadius: '10px', fontSize: '0.88rem', fontFamily: "'DM Sans',sans-serif" } }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
